module.exports = __webpack_public_path__ + "media/images/icon/instagram-343b12ed6ea814d2bf2709a9a7eb87d0.svg";